import { ResumeAlphaData, Step } from '../hooks/use-resume-tailor'

export const ControlBar = (props: { data: ResumeAlphaData; step: Step }) => {
  const { data, step } = props

  return (
    <div className="pb-safe fixed bottom-0 left-0 z-50 w-full border-t bg-background/95 p-3 shadow-[0_-4px_12px_rgba(0,0,0,0.08)] backdrop-blur supports-backdrop-filter:bg-background/60">
      <div className="container mx-auto flex flex-col items-center justify-between gap-4 sm:flex-row">
        <div className="flex w-full flex-row items-center justify-between gap-2 sm:w-auto sm:gap-6">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="flex h-9 w-10 shrink-0 flex-col items-center justify-center rounded-lg border bg-muted/50 font-mono text-xs font-bold sm:h-10 sm:w-12 sm:text-sm">
              {data?.analysis?.ats_score ?? '--'}
            </div>
            <div className="flex min-w-0 flex-col">
              <span className="truncate text-[9px] font-bold tracking-wider text-muted-foreground uppercase sm:text-[10px]">
                Base
              </span>
              <span className="xs:inline hidden truncate text-[11px] font-medium text-foreground/80 sm:text-xs">
                Original
              </span>
            </div>
          </div>

          <div className="hidden h-8 w-px bg-border sm:block" />

          <div className="flex-1 sm:flex-none">
            {step === 'result' ? (
              <div className="flex animate-in items-center gap-2 duration-500 fade-in slide-in-from-left-2 sm:gap-3">
                <div className="flex h-9 w-10 shrink-0 flex-col items-center justify-center rounded-lg bg-primary font-mono text-xs font-bold text-primary-foreground shadow-sm sm:h-10 sm:w-12 sm:text-sm">
                  {data?.result?.ats_score ?? '--'}
                </div>
                <div className="flex min-w-0 flex-col">
                  <span className="truncate text-[9px] font-bold tracking-wider text-primary uppercase sm:text-[10px]">
                    Tailored
                  </span>
                  <div className="flex items-center gap-1.5">
                    <span className="xs:inline hidden text-[11px] font-bold text-foreground sm:text-xs">
                      Optimized
                    </span>
                    {data?.result?.ats_score && data?.analysis?.ats_score && (
                      <span className="rounded bg-green-500/15 px-1 text-[9px] font-bold text-green-600 sm:text-[10px]">
                        +{data.result.ats_score - data.analysis.ats_score}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex items-center gap-2 opacity-50 sm:gap-3">
                <div className="flex h-9 w-10 shrink-0 flex-col items-center justify-center rounded-lg border border-dashed border-muted-foreground/50 font-mono text-xs font-bold text-muted-foreground sm:h-10 sm:w-12 sm:text-sm">
                  --
                </div>
                <div className="flex flex-col">
                  <span className="text-[9px] font-bold tracking-wider text-muted-foreground uppercase sm:text-[10px]">
                    Tailored
                  </span>
                  <span className="xs:inline hidden text-[10px] text-muted-foreground italic">
                    Pending...
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>

        <div
          id="control-bar-step-action"
          className="flex w-full items-center justify-end border-t pt-2 sm:w-auto sm:border-t-0 sm:pt-0"
        ></div>
      </div>
    </div>
  )
}
